import { QueryClient, type VueQueryPluginOptions } from '@tanstack/vue-query';
import { ApiError } from '@shift/contracts';

/**
 * Server state lives here; Pinia holds client state only (README section 4).
 *
 * Retrying a 4xx is pointless and, on a booking flow, actively harmful: a
 * repeated POST could create a second payment hold.
 */
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        if (error instanceof ApiError && error.status < 500) return false;
        return failureCount < 2;
      },
    },
    mutations: { retry: false },
  },
});

export const vueQueryOptions: VueQueryPluginOptions = { queryClient };
